import { setContext } from '@apollo/client/link/context';
import { generate as generateShortUuid } from 'short-uuid';
import { tryToEnsureFreshAccessToken } from '../api';
import { BROWSER_SESSION_ID } from '@upheal/utils/browserSession';
import { FF_BACKEND_ENV } from '@upheal/utils/feature-flags';
import logger from '@upheal/utils/logger';
import { isMutation } from './operation-utils';

export const headersLink = setContext(
    async (operation, { headers, conversationId }) => {
        const accessToken = await tryToEnsureFreshAccessToken();
        const correlationIds = [`web-${generateShortUuid()}`];

        if (FF_BACKEND_ENV.value) {
            if (/^[a-zA-Z-]+$/.test(FF_BACKEND_ENV.value)) {
                correlationIds.push(`feature:${FF_BACKEND_ENV.value}`);
            } else {
                logger.warn(
                    '[link-headers] Invalid FF_BACKEND_ENV value, skipping',
                    {
                        value: FF_BACKEND_ENV.value,
                    },
                );
            }
        }

        if (conversationId) {
            correlationIds.push(`conversation_id:${conversationId}`);
        }

        return {
            headers: {
                ...headers,
                authorization: accessToken ? `Bearer ${accessToken}` : '',
                'correlation-id': correlationIds.join(','),
                'frontend-session-id': BROWSER_SESSION_ID,
                ...(isMutation(operation) && {
                    'X-Nonce': generateShortUuid(),
                }),
            },
        };
    },
);
